<mat-expansion-panel togglePosition="before" [expanded]="(panelState$ | async)?.state === 'expanded'"
  (opened)="dispatchPanelExpanded()" (closed)="dispatchPanelCollapsed()" [disabled]="disabled">
  <mat-expansion-panel-header>
    <mat-panel-title><ng-content select="[coding-section-title]"></ng-content></mat-panel-title>
  </mat-expansion-panel-header>
  <ng-content select="[coding-section-body]"></ng-content>
  <ng-content></ng-content>
</mat-expansion-panel>